import { Component, Inject, OnInit } from '@angular/core';
import { CommonsService } from '../../../services/commons.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-sca-modal',
  templateUrl: './sca-modal.component.html',
  styleUrls: ['./sca-modal.component.scss']
})
export class ScaModalComponent implements OnInit {

  datos: any;
  code: any;
  codeIng: string;

  constructor(
    private serv: CommonsService, private dialogRef: MatDialogRef<ScaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    this.datos = this.serv.getServiceSCA();
    this.codeIng = sessionStorage.getItem('bankCode');
  }

  ngOnInit() {
    
  }

  closeModal(value) {
    let data;
    if (this.code && value) {
      data = {
        validation: this.code
      };
    } else {
      data = {
        validation: 'ok'
      };
    }
    this.dialogRef.close(data);
  }
}
